import { render, staticRenderFns } from "./EgresoIngreso.vue?vue&type=template&id=d955b660"
import script from "./EgresoIngreso.vue?vue&type=script&lang=js"
export * from "./EgresoIngreso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports